import { CalendarPlus, FileText, Play, UserCheck, type LucideIcon } from "lucide-react";
import type { AppointmentStatus } from "@bookdental/schemas";

export type AcaoDaConsulta = {
  rotulo: string;
  icone: LucideIcon;
  /** "iniciar" e "chegou" chamam mutation; os demais só navegam. */
  tipo: "iniciar" | "chegou" | "continuar" | "verAtendimento" | "reagendar";
};

export const ACAO_CHEGOU: AcaoDaConsulta = { rotulo: "Paciente chegou", icone: UserCheck, tipo: "chegou" };

/**
 * A ação principal do diálogo muda com o status — um botão "Iniciar atendimento" numa consulta já
 * atendida ou cancelada oferece o que não faz sentido e esconde o que a pessoa realmente quer dali
 * (rever o que foi feito, ou remarcar).
 */
export function acaoDaConsulta(status: AppointmentStatus): AcaoDaConsulta | null {
  switch (status) {
    case "SCHEDULED":
    case "CONFIRMED":
    case "WAITING":
    case "LATE":
      return { rotulo: "Iniciar atendimento", icone: Play, tipo: "iniciar" };
    case "IN_PROGRESS":
      return { rotulo: "Continuar atendimento", icone: Play, tipo: "continuar" };
    case "COMPLETED":
      return { rotulo: "Ver atendimento", icone: FileText, tipo: "verAtendimento" };
    case "CANCELLED":
    case "NO_SHOW":
      // Falta segue a mesma lógica de cancelada: o que resta a fazer é remarcar.
      return { rotulo: "Reagendar consulta", icone: CalendarPlus, tipo: "reagendar" };
    default:
      return null;
  }
}
